import { STEP_CHECKLISTS, STEP_CONFIRMATION_KEYS } from './useDriverDayActions';

/** Sync state of a done start or end of day step that is only saved on this phone. */
export const STEP_SYNC_STATE = {
	PENDING: 'pending',
	FAILED: 'failed',
};

/**
 * Queued offline entries that complete a driver day step: its My day
 * confirmation for the run, or its checklist for today. Empty for steps
 * completed some other way.
 */
export const getQueuedStepEntries = (step, { queue, serviceRunId, todayDateKey }) => {
	const confirmationKey = STEP_CONFIRMATION_KEYS[step.key];
	const checklistPurpose = STEP_CHECKLISTS[step.key]?.purpose;
	if (!confirmationKey && !checklistPurpose) {
		return [];
	}

	return (queue || []).filter(entry => (
		confirmationKey
			? entry.configKey === 'confirmMyDayStep' &&
				entry.meta?.serviceRunId === serviceRunId &&
				entry.meta?.stepKey === confirmationKey
			: entry.configKey === 'submitChecklist' &&
				entry.meta?.date === todayDateKey &&
				Number(entry.meta?.purpose) === checklistPurpose
	));
};

/** FAILED once a sync attempt failed (retried from the sync banner), else PENDING. */
export const getEntrySyncState = entry => (entry.failureCount ? STEP_SYNC_STATE.FAILED : STEP_SYNC_STATE.PENDING);
